import Config from '../../config';
import {
  handleErrors,
  parseAsJson,
} from '../../utils/requestHelpers';
import fetch from '../../utils/fetchService';

export const importGlJournals = async (GlJournals, periodName) => await fetch(
  Config.endpoints.IMPORT_GL_ACCOUNTS,
  {
    method: 'POST',
    body: JSON.stringify({ GlJournals, periodName }),
  }
)
  .then(handleErrors({ errorMessage: 'Importing GL Journals failed' }));

export const fetchGlAccounts = periodName => fetch(
  Config.endpoints.FETCH_GL_ACCOUNTS
    .replace(/:periodName/, periodName)
)
  .then(handleErrors({ errorMessage: 'Fetching Gl Accounts failed' }))
  .then(parseAsJson);

export const fetchTaxEntryTypes = () => fetch(
  Config.endpoints.FETCH_TAXEXTRY_TYPES
)
  .then(handleErrors({ errorMessage: 'Fetching TaxEntry Types failed' }))
  .then(parseAsJson);

export const fetchTaxEntryActivities = () => fetch(
  Config.endpoints.FETCH_TAXEXTRY_ACTIVITIES
)
  .then(handleErrors({ errorMessage: 'Fetching TaxEntry Activities failed' }))
  .then(parseAsJson);

export const fetchSlAccounts = periodName => fetch(
  Config.endpoints.FETCH_SL_ACCOUNTS
    .replace(/:periodName/, periodName)
)
  .then(handleErrors({ errorMessage: 'Fetching SL Accounts failed' }))
  .then(parseAsJson);

export const fetchSlTaxEntries = periodName => fetch(
  Config.endpoints.FETCH_SL_TAX_ENTRIES
    .replace(/:periodName/, periodName)
)
  .then(handleErrors({ errorMessage: 'Fetching Sl Tax Entries failed' }))
  .then(parseAsJson);

